function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

export function formatAiTextLine(line) {
  return escapeHtml(line)
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
}

export function formatAiTextToParagraphs(text) {
  if (!text?.trim()) return ''

  return text
    .split('\n')
    .filter((line) => line.trim())
    .map(
      (line) =>
        `<p style="margin-bottom:8px;line-height:1.8;">${formatAiTextLine(line)}</p>`,
    )
    .join('')
}
